export const INITIALIZING_APPLICATION = 'INITIALIZING_APPLICATION'
export const APPLICATION_INITIALIZED = 'APPLICATION_INITIALIZED'
export const UPDATE_URL = 'UPDATE_URL'
export const URL_PARSED = 'URL_PARSED'
export const URL_PARAMS = 'URL_PARAMS'
export const UPDATED = `${URL_PARAMS}_UPDATED`
export const REPLACE_PARAMS = 'REPLACE_PARAMS'
export const APP_ENTER_STARTED = 'APP_ENTER_STARTED'
export const PARTNER_CONFIGURATION_FROM_S3 = 'PARTNER_CONFIGURATION_FROM_S3'
